<div (click)="handleSelection()" class="menu-container">
  <p>{{ header }}</p>
</div>

<div [@slideInOut]="isOpen ? 'in' : 'out'" class="pl-15">
  <mat-list-item *ngFor="let menuConfig of sideMenuConfigs" (click)="loadContent(menuConfig)" [ngClass]="{active: isActive(menuConfig)}">
    <div matListItemTitle>{{menuConfig.descrizione}}</div>
  </mat-list-item>
</div>
